import _ from 'lodash';

const exported = {
  // this is probably a less efficient pure render mixin
  // it works neatly with valueLink
  // it does nested object comparisons - do try to have small props trees when using it.

  shouldComponentUpdate(nextProps, nextState) {
    if (!_.isEqual(_.keys(this.state), _.keys(nextState))) {
      return true;
    }
    if (!_.isEqual(_.keys(this.props), _.keys(nextProps))) {
      return true;
    }
    for (let key in nextProps) {
      if (_.includes(['onChange', 'onBlur', 'onKeyUp', 'onKeyDown'], key)) {
        continue;
      }
      if (key === 'valueLink') {
        if (nextProps.valueLink.value !== this.props.valueLink.value) {
          return true;
        }
      } else if (
        !_.eq(
          nextProps != null ? nextProps[key] : undefined,
          this.props != null ? this.props[key] : undefined
        )
      ) {
        return true;
      }
    }
    for (let key in nextState) {
      if (
        !_.eq(
          nextState != null ? nextState[key] : undefined,
          this.state != null ? this.state[key] : undefined
        )
      ) {
        return true;
      }
    }
    return false;
  }
};

export default exported;

export const { shouldComponentUpdate } = exported;
